import "@/App.css";
import Landing from "@/pages/Landing";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Landing />
    </div>
  );
}

export default App;
